import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { ContactDetail } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.contacts.get` (frame q2). No read while no contact is open. */
export function useContactDetail(accountId: number, workspaceContactUuid: string | null) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.contacts.get.queryOptions(
      { accountId, workspaceContactUuid: workspaceContactUuid ?? '' },
      { enabled: workspaceContactUuid !== null, retry: false }
    )
  );
  const retry = useRetry(query.refetch);
  return { detail: query.data as ContactDetail | undefined, isLoading: query.isLoading, error: query.error, retry };
}
